import { render } from "./ColumnsBlock.vue?vue&type=template&id=5606059a&scoped=true"
import script from "./ColumnsBlock.vue?vue&type=script&lang=js"
export * from "./ColumnsBlock.vue?vue&type=script&lang=js"

import "./ColumnsBlock.vue?vue&type=style&index=0&id=5606059a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5606059a"]])

export default __exports__